import { getApiClient } from './client';
import type { SearchResponse, SearchScopeKind } from '@/types/domain';
import type { SearchFilters } from '@/types/searchFilters';
import { hasActiveFilters, filtersToPayload } from '@/types/searchFilters';

// Portée résolue en identifiants concrets, prête à envoyer au backend. Les ids
// sont résolus depuis l'onglet actif au moment de la requête (cf. useSearch).
export interface SearchScope {
  scope: SearchScopeKind;
  containerId?: string | null;
  folderId?: string | null;
}

export async function search(
  q: string,
  scope?: SearchScope,
  filters?: SearchFilters,
): Promise<SearchResponse> {
  const active = filters ? hasActiveFilters(filters) : false;
  // Un mot-clé N'EST PLUS REQUIS : « les mails de X en juin » se cherche par
  // filtres seuls. Il faut en revanche au moins l'un des deux, sinon la requête
  // demanderait l'archive entière — le serveur la refuse, autant ne pas la poser.
  if (!q.trim() && !active) return { containers: [], folders: [], mails: [] };
  const json: Record<string, unknown> = {};
  if (q.trim()) json.q = q;
  // 'all' est le défaut côté serveur : on n'envoie la portée que si elle diffère,
  // ce qui garde la requête (et la clé de cache) minimales dans le cas courant.
  if (scope && scope.scope !== 'all') {
    json.scope = scope.scope;
    if (scope.containerId) json.containerId = scope.containerId;
    if (scope.folderId) json.folderId = scope.folderId;
  }
  if (filters) Object.assign(json, filtersToPayload(filters));
  return getApiClient().post('outlook-search', { json }).json<SearchResponse>();
}
